import * as C from './styles';
type buttonType = {
    text: string,
    onclickHandle?: ()=>void,
    primary?: boolean
}
export const Button = ({text,primary, onclickHandle}: buttonType)=>{
    return(
        <C.Button primary={primary} type='button' value={text} formTarget="_blank" onClick={onclickHandle}/>
    )
}